import { gql } from '@apollo/client';

export const DAMAGE_CLAIM_FIELDS = gql`
  fragment DamageClaimFieldsForService on DamageClaim {
    id
    shortId
    claimNum
    bookingId
    reporterId
    hostId
    guestId
    carId
    status
    damageType
    physicalDamageSubcategory
    beforePhotos
    afterPhotos
    policeReportFiled
    waterInsideCar
    whoWasDriving
    anyoneInjured
    anotherPersonInvolved
    isCarDriveable
    didVehicleLoseFluids
    didAirbagsDeploy
    incidentOccurredAt
    incidentLocation {
      country
      streetAddress
      city
      postalCode
    }
    damagedParts
    damagedPartsOtherDescription
    mechanicalIssues
    mechanicalIssueOtherDescription
    damageDescription
    additionalInfo
    repairShopInfo {
      shopName
      address
      contactName
      phoneNumber
    }
    repairEstimateRange
    claimAmount
    approvedAmount
    depositPaymentIntentId
    adminNotes
    reviewedBy
    reviewedAt
    response {
      responseContent
      responsePhotos
      responderId
      createdAt
    }
    responderId
    counterpartyReviewed
    responseDeadline
    createdAt
    updatedAt
  }
`;

export const GET_MY_DAMAGE_CLAIMS = gql`
  query GetMyDamageClaims {
    myDamageClaims {
      ...DamageClaimFieldsForService
      booking {
        id
        startAt
        endAt
        productType
        car {
          id
          name
          make
          model
          year
          thumbnailUrl
        }
        guest {
          id
          firstName
          lastName
          displayName
        }
        host {
          id
          firstName
          lastName
          displayName
        }
      }
    }
  }
  ${DAMAGE_CLAIM_FIELDS}
`;

export const GET_DAMAGE_CLAIMS_BY_BOOKING = gql`
  query GetDamageClaimsByBookingForService($bookingId: String!) {
    damageClaimsByBooking(bookingId: $bookingId) {
      ...DamageClaimFieldsForService
    }
  }
  ${DAMAGE_CLAIM_FIELDS}
`;

export const GET_DAMAGE_CLAIM = gql`
  query GetDamageClaimById($id: String!) {
    damageClaim(id: $id) {
      ...DamageClaimFieldsForService
      booking {
        id
        startAt
        endAt
        productType
        car {
          id
          name
          make
          model
          year
          thumbnailUrl
        }
        guest {
          id
          firstName
          lastName
          displayName
          email
          phoneNumber
        }
        host {
          id
          firstName
          lastName
          displayName
          email
        }
        tripStartImages {
          url
        }
        tripEndImages {
          url
        }
      }
      reporter {
        id
        firstName
        lastName
        displayName
      }
      responder {
        id
        firstName
        lastName
        displayName
      }
    }
  }
  ${DAMAGE_CLAIM_FIELDS}
`;

export const WITHDRAW_DAMAGE_CLAIM = gql`
  mutation WithdrawDamageClaimMutation($claimId: String!) {
    withdrawDamageClaim(claimId: $claimId) {
      ...DamageClaimFieldsForService
    }
  }
  ${DAMAGE_CLAIM_FIELDS}
`;

export const CAN_RESPOND_TO_CLAIM = gql`
  query CanRespondToClaim($claimId: String!) {
    canRespondToClaim(claimId: $claimId) {
      canRespond
      reason
      deadline
    }
  }
`;

export const RESPOND_TO_DAMAGE_CLAIM = gql`
  mutation RespondToDamageClaim($input: RespondToClaimInput!) {
    respondToDamageClaim(input: $input) {
      ...DamageClaimFieldsForService
    }
  }
  ${DAMAGE_CLAIM_FIELDS}
`;
